import React, { useState } from "react";
import Sidebar from "../components/Sidebar";
import ContactDataNavbar from "../components/ContactDataNavbar";
import DataTable from "../components/DataTable";

const ContactData = () => {
  const [sidebarOpen, setSidebarOpen] = useState(true);

  const handleSidebarStateChange = (isOpen) => {
    setSidebarOpen(isOpen);
  };
  return (
    <div>
      <Sidebar debarStateChange={handleSidebarStateChange} />
      <ContactDataNavbar />
      <DataTable />
    </div>
  );
};

export default ContactData;
